import React from "react";
var __jsx = React.createElement;
import APP_CONFIGURATION from "@lib/app.config";
import useCssModules from "@lib/hooks/use-css-modules";
import ExtendAnimatedDiv from "@modules/shared/components/extend-animated-div";
import SupportContactItems from "@modules/shared/components/support-contact-items";
import Icons from "@modules/icons";
import { useTranslations } from "next-intl";
import { useState } from "react";
export default function ContactInfo() {
  var _cssModules$footers$f;
  const {
    0: open,
    1: setOpen
  } = useState(false);
  const t = useTranslations("Shared.Layout");
  const {
    cssModules
  } = useCssModules();
  const {
    contactInfoContainerClassNames,
    contacInfoTitleClassNames,
    contacInfoTitleArrowClassNames,
    contacInfoSupportMessageClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerInterbank) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx("div", {
    className: contactInfoContainerClassNames
  }, __jsx("div", {
    className: "flex flex-row justify-between items-center",
    onClick: () => setOpen(!open)
  }, __jsx("h5", {
    className: contacInfoTitleClassNames
  }, t("SUPPORT_TITLE")), __jsx("div", {
    className: "md:hidden"
  }, open ? __jsx(Icons.chevronUp, {
    className: contacInfoTitleArrowClassNames
  }) : __jsx(Icons.chevronDown, {
    className: contacInfoTitleArrowClassNames
  }))), __jsx("div", {
    className: "flex flex-col gap-5"
  }, __jsx("div", {
    className: "block md:hidden"
  }, __jsx(ExtendAnimatedDiv, {
    isOpen: open
  }, __jsx("p", {
    className: contacInfoSupportMessageClassNames
  }, t("SUPPORT_CONTACT_MESSAGE")), __jsx("br", null), __jsx(SupportContactItems, null), __jsx("br", null))), __jsx("div", {
    className: "hidden md:flex md:flex-col gap-5"
  }, __jsx("p", {
    className: contacInfoSupportMessageClassNames
  }, t("SUPPORT_CONTACT_MESSAGE")), __jsx(SupportContactItems, {
    color: APP_CONFIGURATION.colors.footer.text_color
  }))));
}